"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { styled } from "styled-components";
import { useStepTitle } from "./hooks/useStepTitle.js";
import { CenteredText } from "../common.js";
import { AnimatePresence, motion } from "framer-motion";
import { useModalStore } from "../../stores/index.js";
import { BODY_MOTION_VARIANTS, BODY_TRANSITION } from "../../constants/constants.js";
const Header = () => {
  const { title } = useStepTitle();
  const stepDirection = useModalStore((state) => state.stepDirection);
  const currentStep = useModalStore((state) => state.step);
  return /* @__PURE__ */ jsx(AnimatePresence, { mode: "popLayout", initial: false, custom: stepDirection, children: /* @__PURE__ */ jsx(
    Container,
    {
      custom: stepDirection,
      variants: BODY_MOTION_VARIANTS,
      initial: "enter",
      animate: "center",
      exit: "exit",
      transition: BODY_TRANSITION,
      slot: "header",
      id: "header",
      children: /* @__PURE__ */ jsx(CenteredText, { weight: "semiBold", color: "secondary", children: title })
    },
    ["ADD_FUNDS_BUY", "ADD_FUNDS_RECEIVE", "ADD_FUNDS_WITHDRAW"].includes(currentStep) ? "ADD_FUNDS" : currentStep
  ) });
};
const Container = styled(motion.div)`
  position: absolute;
  top: 16px;
  width: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
`;
export {
  Header
};
